// opervex-frontend/src/layout/Footer/Footer.js

import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./Footer.css";

const Footer = () => {
  const [version, setVersion] = useState(null);
  const [showAbout, setShowAbout] = useState(false);

  useEffect(() => {
    const loadVersion = async () => {
      try {
        const response = await fetch("/version.json");

        if (!response.ok) {
          throw new Error("Não foi possível carregar version.json");
        }

        const data = await response.json();

        setVersion(data);
      } catch (error) {
        console.error("Erro ao carregar versão:", error);
      }
    };

    loadVersion();
  }, []);

  const handleVersionClick = () => {
    setShowAbout(true);
  };

  return (
    <>
      <footer className="layout-footer">
        <div className="footer-left">© {new Date().getFullYear()} Opervex. Todos os direitos reservados.</div>

        <div className="footer-center">Desenvolvido por Opervex</div>

        <div className="footer-right">
          <button type="button" className="footer-version-button" onClick={handleVersionClick}>
            {version && (
              <>
                <span className="footer-version">v{version.version}</span>

                <span className="footer-separator">•</span>

                <span className="footer-build">Build {version.build}</span>

                <span className="footer-separator">•</span>

                <span className="footer-commit">{version.commit}</span>
              </>
            )}
          </button>
        </div>
      </footer>

      <Modal show={showAbout} onHide={() => setShowAbout(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Sobre o Sistema</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <table className="table table-sm mb-0">
            <tbody>
              <tr>
                <th>Sistema</th>
                <td>{version?.system}</td>
              </tr>

              <tr>
                <th>Versão</th>
                <td>{version?.version}</td>
              </tr>

              <tr>
                <th>Build</th>
                <td>{version?.build}</td>
              </tr>

              <tr>
                <th>Commit</th>
                <td>{version?.commit}</td>
              </tr>

              <tr>
                <th>Branch</th>
                <td>{version?.branch}</td>
              </tr>

              <tr>
                <th>Ambiente</th>
                <td>{version?.environment}</td>
              </tr>

              <tr>
                <th>Build Date</th>
                <td>{version?.buildDate ? new Date(version.buildDate).toLocaleString("pt-BR").replace(",", " -") : ""}</td>
              </tr>
            </tbody>
          </table>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAbout(false)}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Footer;
